const GATED_CONTENT_SCRIPT_URL =
  import.meta.env.VITE_GATED_CONTENT_SCRIPT_URL ||
  "https://www.storydoc.com/assets/js/gated-content.js";

const gatedContentScript = `<script async src="${GATED_CONTENT_SCRIPT_URL}"></script>`;

// The whole gate config travels in ONE typed JSON block (triple-stache: raw
// JSON, no HTML escaping, read back via textContent). gateJson is derived by
// the backend normalizer from the canonical `fields`. window.gatedContentData
// exists only on legacy templates; the viewer script falls back to it for
// stories published before this block.
export const gatedContentData = `
      <script type="application/json" id="sd-gated-content-config">{{{system.gatedContent.gateJson}}}</script>
      <script>
      window.isGatedContent = "{{system.gatedContent.gatedContent}}";
      </script>
      ${gatedContentScript}
    `;
export const gatedContentBody = `
      <script>
        if(window.isGatedContent === 'true') {
          document.documentElement.classList.add('gated-content');
          document.body.classList.add('gated-content');
          // THE LOADER IS NOT CONTENT. Everything else that sits directly
          // under <body> is hidden until the gate is answered, and the loader
          // puts its overlay there too (loader.js, insertAdjacentHTML on
          // body) -- so a gated document showed a WHITE SCREEN for as long as
          // the gate took to render, or for the whole fail-open wait below
          // when it never did. It is exempt: a fixed, opaque, full-screen
          // overlay that covers the story rather than revealing any of it,
          // and it takes itself down again.
          document.head.insertAdjacentHTML("beforeend", '<style type="text/css">html.gated-content,body.gated-content{overflow:hidden}body.gated-content:not(.printToPdf)>*:not(section#sd-gated-content):not(#loader-n7FEhFPpZGvUY9Z),body:not(.gated-content)>section#sd-gated-content{display:none !important;}</style>');
          // Fail-open: if the gate script never renders its section (blocked,
          // unreachable, or crashed), unhide the story instead of leaving a
          // blank page. The gate is soft lead-capture; the content is already
          // in the DOM either way.
          var failOpen = function () {
            if (document.querySelector('section#sd-gated-content')) return;
            document.documentElement.classList.remove('gated-content');
            document.body.classList.remove('gated-content');
          };
          // A script that failed to load has already told us everything the
          // wait below would: it is not going to render a gate. Four seconds
          // of a blank page is what the reader used to get out of an ad
          // blocker or a bad URL -- the loader is gone by then, since the
          // presentation takes it down as soon as it has rendered.
          var gateScript = document.querySelector('script[src*="gated-content"]');
          if (gateScript) gateScript.addEventListener('error', failOpen);
          setTimeout(failOpen, 4000);
        }
      </script>
    `;
